import { ratingService } from "../../services";
import TrendsPage from "../../components/Companies/Trends/TrendsPage"
import CompaniesPage from "../../components/Companies/CompaniesPage/CompaniesPage"
import { getCompaniesPageData } from "../../components/Companies/helpers/get-companies-page-data"
import { getCompaniesTrendsPageData } from "../../components/Companies/helpers/get-companies-trends-page-data"

export async function getStaticPaths() {
  const routerPaths = await ratingService.getRouterPaths();

  const paths = routerPaths.map((path) => {
    const slug = path.url.split('/').filter(Boolean);
    return { params: { slug } };
  });

  return {
    paths,
    fallback: 'blocking',
  };
}

export async function getStaticProps(context) {
  const { params } = context
  const { slug = [] } = params

  const resolvedUrl = `/companies/${slug.join('/')}`

  const isTrendsPage = slug[slug.length - 1] === "trends"

  const query = { slug }

  const pageData = isTrendsPage
    ? await getCompaniesTrendsPageData(query, resolvedUrl)
    : await getCompaniesPageData(query, resolvedUrl)

  if (pageData.notFound) {
    return { notFound: true }
  }

  return { props: pageData, revalidate: 86400 }
}

const Companies = (props) => {
  const { isTrendsPage } = props

  return isTrendsPage ? (
    <TrendsPage {...props} />
  ) : (
    <CompaniesPage {...props} />
  )
}

export default Companies
